/**
 * AdminTutorsPlaceholder
 * Placeholder for the admin tutors list (Part 4).
 */

const AdminTutorsPlaceholder = () => (
  <div className="flex flex-col items-center justify-center h-64 text-center">
    <h2 className="text-xl font-playfair font-bold text-[#17386E] mb-2">
      Répétiteurs
    </h2>
    <p className="text-gray-500 font-montserrat text-sm">
      Fonctionnalité disponible dans la Partie 4.
    </p>
  </div>
);

export default AdminTutorsPlaceholder;
